/* @flow */
export default {
    dropdown: {
        noSelectedItem: '< Select Item >',
        noSelection: '(no selection)',
        allSelected: '(all selected)',
        multipleSelections: '(multiple selections)',
    },
};
